<template>
  <BModal :id="id" :visible="show" scrollable size="lg" body-class="p-0 mb-3" :hide-footer="true" @hide="$emit('hide')">
    <template #modal-header>
      <h5 class="mb-3 mt-auto ml-auto mr-auto modal-title">
        {{ product.category_name }}
      </h5>
      <button type="button" class="modal-close" aria-label="Close" @click="$emit('hide')">
        <i class="fa fa-times-thin" style="font-size: 1.5em" />
      </button>
    </template>
    <div class="pdp-banner px-4">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-12 text-center">
              <span class="text-header-500">
                {{ product.product_name }}
                {{ product.cultivar_name ? `(${product.cultivar_name})` : "" }}
              </span>
            </div>
            <div class="col-md-4 offset-0 offset-md-4">
              <div class="text-center">
                <span class="text-header-200">Available</span><br />
                <i v-if="batch.disable_inventory_tracking" class="fa-fw fas fa-infinity" />
                <span v-else class="text-header-300" :class="{ 'text-danger': ptoTotal + existingQuantity > batch.quantity }">{{
                  batch.quantity
                }}</span>
                <span class="text-header-medium"> {{ product.product_unit_of_measurement }}s </span>
                <p v-if="existingQuantity">{{ existingQuantity }} in <i class="fa fa-shopping-cart" /></p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3 col-sm-3 col-md-4">
          <div class="row">
            <div class="col-md-9 col-lg-6 text-center center-content pt-lg-3">
              <span class="text-header-100">Quantity</span><br />
              {{ ptoTotal }}
              <span class="text-header-200" style="">{{ product.product_unit_of_measurement }}s</span>
              <div v-if="ptoTotal + existingQuantity > batch.quantity && !batch.disable_inventory_tracking">
                <span class="text-danger">Insufficient Quantity</span>
              </div>
            </div>
            <div class="col-lg-5 pt-lg-3">
              <br />
              <BushelBtn
                variant="success"
                class="btn btn-block"
                :disabled="
                  !ptoTotal ||
                  (ptoTotal + existingQuantity > batch.quantity && !batch.disable_inventory_tracking) ||
                  !noDecimals ||
                  (batch.disable_inventory_tracking && ptoTotal < 1)
                "
                @click="createItems"
              >
                <i class="fas fa-plus" />
              </BushelBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-2">
      <div class="col-md-4 offset-md-1 text-left">
        <strong>Pack To Order Selector</strong><br />
        <small>In the event that a specific package isn't available it should be greyed out.</small>
        <br /><br />
        <small>The total amount of Grams will be automatically calculated based on available stock and packaging options.</small>
        <br /><br />
        <small>Custom Pricing on Pack To Order items is not displayed here, but will be reflected in the cart.</small>
        <br /><br />
      </div>
      <div class="col-md-6">
        <BushelCard body-class="p-0 overflow-hidden">
          <div class="row text-center p-2" style="background-color: rgba(55, 63, 67, 0.12)">
            <div class="col-4 mb-1 text-center">
              <label class="col-form-label" style="height: 61px"
                >1 Gram<small style=""><br />{{ currency(batch.pto_oneg_listing_price) }}</small></label
              >
              <BushelTextInput v-model="newItem.pto_oneg_quantity" :disabled="!batch.pto_oneg_listing_price" type="number" thin hide-label />
            </div>
            <div class="col-4 mb-3 text-center">
              <label class="col-form-label" style="height: 61px"
                >2 Gram<small style=""><br />{{ currency(batch.pto_twog_listing_price) }}</small></label
              >

              <BushelTextInput v-model="newItem.pto_twog_quantity" :disabled="!batch.pto_twog_listing_price" type="number" thin hide-label />
            </div>
            <div class="col-4 mb-3 text-center">
              <label class="col-form-label" style="height: 61px"
                >1/8 Oz<small style=""><br />{{ currency(batch.pto_eighthoz_listing_price) }}</small></label
              >

              <BushelTextInput v-model="newItem.pto_eighthoz_quantity" :disabled="!batch.pto_eighthoz_listing_price" type="number" thin hide-label />
            </div>
            <div class="col-4 mb-3 text-center">
              <label class="col-form-label" style="height: 61px"
                >1/4 Oz<small style=""><br />{{ currency(batch.pto_quarteroz_listing_price) }}</small></label
              >

              <BushelTextInput
                v-model="newItem.pto_quarteroz_quantity"
                :disabled="!batch.pto_quarteroz_listing_price"
                type="number"
                thin
                hide-label
              />
            </div>
            <div class="col-4 mb-3 text-center">
              <label class="col-form-label" style="height: 61px"
                >1/2 Oz<small style=""><br />{{ currency(batch.pto_halfoz_listing_price) }}</small></label
              >

              <BushelTextInput v-model="newItem.pto_halfoz_quantity" :disabled="!batch.pto_halfoz_listing_price" type="number" thin hide-label />
            </div>
            <div class="col-4 mb-3 text-center">
              <label class="col-form-label" style="height: 61px"
                >1 Oz<small style=""><br />{{ currency(batch.pto_oneoz_listing_price) }}</small></label
              >

              <BushelTextInput v-model="newItem.pto_oneoz_quantity" :disabled="!batch.pto_oneoz_listing_price" type="number" thin hide-label />
            </div>
            <div class="col-4 mb-3 text-center">
              <label class="col-form-label" style="height: 61px"
                >1/4 LB<small style=""><br />{{ currency(batch.pto_quarterpound_listing_price) }}</small></label
              >

              <BushelTextInput
                v-model="newItem.pto_quarterpound_quantity"
                :disabled="!batch.pto_quarterpound_listing_price"
                type="number"
                thin
                hide-label
              />
            </div>
            <div class="col-4 mb-3 text-center">
              <label class="col-form-label" style="height: 61px"
                >1/2 LB<small style=""><br />{{ currency(batch.pto_halfpound_listing_price) }}</small></label
              >

              <BushelTextInput
                v-model="newItem.pto_halfpound_quantity"
                :disabled="!batch.pto_halfpound_listing_price"
                type="number"
                thin
                hide-label
              />
            </div>
            <div class="col-4 mb-3 text-center">
              <label class="col-form-label" style="height: 61px"
                >1 LB <small><br />{{ currency(batch.pto_onepound_listing_price) }}</small></label
              >

              <BushelTextInput v-model="newItem.pto_onepound_quantity" :disabled="!batch.pto_onepound_listing_price" type="number" thin hide-label />
            </div>
          </div>
        </BushelCard>
      </div>
    </div>
  </BModal>
</template>

<script>
import { currency } from "@/services/filters";

export default {
  components: {},
  props: {
    show: { type: Boolean, required: true },
    id: { type: String, default: "ptoModal" },
    product: { type: Object, required: true },
    batch: { type: Object, required: true },
    existingQuantity: { type: Number, default: 0 },
  },
  emits: ["createPackToOrderItems", "hide"],
  data() {
    return {
      newItem: {
        batch_id: this.batch.id,
        company_id: this.product.company_id,
        product_id: this.product.id,
        pto_oneg_quantity: 0,
        pto_twog_quantity: 0,
        pto_eighthoz_quantity: 0,
        pto_quarteroz_quantity: 0,
        pto_halfoz_quantity: 0,
        pto_oneoz_quantity: 0,
        pto_quarterpound_quantity: 0,
        pto_halfpound_quantity: 0,
        pto_onepound_quantity: 0,
        pto_product: true,
        sample: false,
      },
    };
  },
  computed: {
    noDecimals() {
      if (
        this.newItem.pto_oneg_quantity % 1 == 0 &&
        this.newItem.pto_twog_quantity % 1 == 0 &&
        this.newItem.pto_eighthoz_quantity % 1 == 0 &&
        this.newItem.pto_quarteroz_quantity % 1 == 0 &&
        this.newItem.pto_halfoz_quantity % 1 == 0 &&
        this.newItem.pto_oneoz_quantity % 1 == 0 &&
        this.newItem.pto_quarterpound_quantity % 1 == 0 &&
        this.newItem.pto_halfpound_quantity % 1 == 0 &&
        this.newItem.pto_onepound_quantity % 1 == 0
      ) {
        return true;
      }
      return false;
    },
    ptoTotal() {
      return (
        Number(this.newItem.pto_oneg_quantity) +
        Number(this.newItem.pto_twog_quantity) * 2 +
        Number(this.newItem.pto_eighthoz_quantity) * 3.5 +
        Number(this.newItem.pto_quarteroz_quantity) * 7 +
        Number(this.newItem.pto_halfoz_quantity) * 14 +
        Number(this.newItem.pto_oneoz_quantity) * 28 +
        Number(this.newItem.pto_quarterpound_quantity) * 113.5 +
        Number(this.newItem.pto_halfpound_quantity) * 227 +
        Number(this.newItem.pto_onepound_quantity) * 454
      );
    },
  },
  mounted() {},
  methods: {
    currency,
    createItems() {
      if (this.noDecimals) {
        if (this.ptoTotal <= this.batch.quantity || (this.batch.disable_inventory_tracking && this.ptoTotal >= 1)) {
          const data = { ...this.newItem };
          data.quantity = this.ptoTotal;
          this.$emit("createPackToOrderItems", data);
          this.$emit("hide");
        }
      }
    },
  },
};
</script>
